const ORIGIN = "https://lesvita.com";

/**
 * SEO metadata por rota.
 *
 * Convenções:
 *  - title   : ≤ 60 chars  (Google trunca após isso)
 *  - description : 140–155 chars  (snippet ideal no SERP)
 *  - ogTitle / ogDescription : otimizados para compartilhamento social
 *  - keywords : apenas páginas indexáveis (noindex = false)
 *  - noindex : true em rotas autenticadas, dinâmicas ou operacionais
 */
export const seo = {

  // ─── INDEXÁVEIS ──────────────────────────────────────────────────────────

  home: {
    title: "LesVita | Avaliação Corporal e Scan de Refeição com IA",
    description:
      "Avalie sua composição corporal e suas refeições só com fotos. IA mede calorias, macros e % de gordura em minutos. Grátis para começar.",
    ogTitle: "Avaliação corporal e scan de refeição com IA — LesVita",
    ogDescription:
      "Tire uma foto, receba análise completa. Composição corporal, calorias e macros sem equipamento. Comece grátis agora.",
    canonical: `${ORIGIN}/`,
    keywords: [
      "avaliação corporal por foto",
      "scan de refeição com IA",
      "composição corporal IA",
      "calorias por foto",
      "app de saúde com inteligência artificial",
    ],
    noindex: false,
  },

  addLesVita: {
    title: "Instale o App LesVita | PWA Gratuito no Celular",
    description:
      "Adicione a LesVita à tela inicial do seu celular. Avaliação corporal com IA e scan de refeições sempre a um toque. Sem baixar nada.",
    ogTitle: "LesVita no seu celular — instale agora, é grátis",
    ogDescription:
      "App PWA da LesVita: avaliação corporal e scan de refeições com IA direto na tela inicial, sem precisar de loja de apps.",
    canonical: `${ORIGIN}/AddLesVita`,
    keywords: [
      "instalar app LesVita",
      "PWA avaliação corporal",
      "app saúde sem download",
      "progressive web app dieta",
    ],
    noindex: false,
  },

  photoNutri: {
    title: "Scan de Refeição com IA | Calorias por Foto — LesVita",
    description:
      "Fotografe seu prato e descubra calorias, proteínas, carboidratos e gorduras em segundos. Inteligência artificial da LesVita. 100% grátis.",
    ogTitle: "Descubra as calorias do seu prato em 1 foto — LesVita",
    ogDescription:
      "IA analisa seu prato e entrega macros completos em segundos. Sem digitar nada, sem pesagem. Experimente grátis.",
    canonical: `${ORIGIN}/photo-nutri`,
    keywords: [
      "scan de refeição IA",
      "calorias por foto",
      "macros por foto",
      "app contar calorias foto",
      "análise nutricional inteligência artificial",
    ],
    noindex: false,
  },

  datasetVoluntar: {
    title: "Seja Voluntário do Dataset de IA | LesVita",
    description:
      "Contribua com o treinamento da nossa IA de avaliação corporal. Participe como voluntário de forma segura, anônima e com propósito científico.",
    ogTitle: "Ajude a treinar a IA de avaliação corporal da LesVita",
    ogDescription:
      "Voluntários ajudam a IA da LesVita a ser mais precisa. Participação anônima, segura e com impacto real na saúde digital.",
    canonical: `${ORIGIN}/dataset-voluntar`,
    keywords: [
      "voluntário dataset IA saúde",
      "treinar inteligência artificial",
      "colaboração científica composição corporal",
    ],
    noindex: false,
  },

  politicas: {
    title: "Privacidade e Termos de Uso | LesVita",
    description:
      "Entenda como a LesVita coleta, usa e protege seus dados pessoais e sensíveis. Política de Privacidade e Termos em conformidade com a LGPD.",
    ogTitle: "Política de Privacidade e Termos de Uso — LesVita",
    ogDescription:
      "Transparência total sobre seus dados. Leia a Política de Privacidade e os Termos de Uso da LesVita, em conformidade com a LGPD.",
    canonical: `${ORIGIN}/politicas`,
    keywords: [
      "política de privacidade LesVita",
      "termos de uso",
      "LGPD saúde digital",
      "proteção de dados app saúde",
    ],
    noindex: false,
  },

  // ─── NOINDEX (rotas autenticadas, operacionais ou dinâmicas) ─────────────

  login: {
    title: "Entrar na LesVita | Login",
    description:
      "Acesse sua conta LesVita para acompanhar avaliações, análises de refeições e seu progresso com IA.",
    canonical: `${ORIGIN}/login`,
    noindex: true,
  },

  plataformaPessoal: {
    title: "Minha Plataforma | LesVita",
    description:
      "Área pessoal: avaliações corporais, histórico de refeições, planos e evolução ao longo do tempo.",
    canonical: `${ORIGIN}/plataforma/pessoal`,
    noindex: true,
  },

  stepColeta: {
    title: "Coleta de Avaliação Corporal | LesVita",
    description:
      "Siga o passo a passo para fotografar sua avaliação corporal com IA. Simples, rápido e seguro.",
    canonical: `${ORIGIN}/StepColeta`,
    noindex: true,
  },

  objetivos: {
    title: "Seus Objetivos de Saúde | LesVita",
    description:
      "Defina seus objetivos para que a IA da LesVita personalize seu plano de dieta, treino e acompanhamento.",
    canonical: `${ORIGIN}/objetivo`,
    noindex: true,
  },

  resultRefeicao: {
    title: "Resultado da Análise de Refeição | LesVita",
    description:
      "Confira a análise nutricional completa da sua refeição gerada por IA e compartilhe com quem quiser.",
    canonical: `${ORIGIN}/result`,
    noindex: true,
  },

  salaConsulta: {
    title: "Sala de Consulta | LesVita",
    description: "Espaço reservado para consultas na plataforma LesVita.",
    canonical: `${ORIGIN}/SalaConsulta`,
    noindex: true,
  },

  giroscopio: {
    title: "Giroscópio | LesVita",
    description: "Ferramenta auxiliar de coleta de orientação do dispositivo.",
    canonical: `${ORIGIN}/giroscopio`,
    noindex: true,
  },

  dataset: {
    title: "Dataset Interno | LesVita",
    description: "Página interna de gerenciamento de dataset. Não indexar.",
    canonical: `${ORIGIN}/dataset`,
    noindex: true,
  },

  // ─── LGPD: rota de exclusão de conta deve ser encontrável ────────────────
  // Manter indexável facilita auditoria de conformidade e tranquiliza usuários.
  excluirConta: {
    title: "Excluir Minha Conta | LesVita",
    description:
      "Solicite a exclusão permanente da sua conta e dados na LesVita, em conformidade com a LGPD. Processo simples e sem burocracia.",
    ogTitle: "Como excluir sua conta na LesVita",
    ogDescription:
      "Exclua sua conta e todos os seus dados em poucos passos. Seus direitos garantidos pela LGPD, respeitados pela LesVita.",
    canonical: `${ORIGIN}/excluir-conta`,
    keywords: ["excluir conta LesVita", "deletar dados LGPD", "direito ao esquecimento"],
    noindex: false, // LGPD art. 18 — usuário precisa encontrar essa rota
  },
};